<!-- ---------- Desktop card ---------- -->
<div
  class="card-ftd {{countryConfig.productCard.cardClassCountry}} {{product.objectID}}"
  *ngIf="isCardVisible()"
  [class.card-home]="isHome"
  [class.card-ftd__card-offer]="isOffer"
  [class.card-vto]="isVTO"
  [class.card-ftd__mini-card]="isMini"
  [class.card-ftd--sustitutes]="isSustitutes"
  [class.add-information]="configModule?.additionalInf"
  [class.add-information__card-offer]="isOffer && configModule?.additionalInf"
  [class.add-information__column]="!isAlgolia && !isHome && !isCarousel"
  [class.belleza-loreal]="isLorealDesign"
  data-insights-object-id="{{product.objectID}}"
  data-insights-position="{{product.__position}}"
  data-insights-query-id="{{product.__queryID}}"
  [ngClass]="{
    'prime-border': getPrimeBorder(),
    'card-video-loreal': isLorealDesign,
    'group-card': groupType === 'suggests' || groupType === 'highlights'
  }"
>
  <div
    data-ts-clickable
    [id]="idPrefix + product.id + '-detail-redirect'"
    *ngIf="showCardUnique()"
    class="card-ftd__card-unique"
    [class.i-vto]="!isVTO && product.filterCategories"
    [class.i-filters-vto]="isVTO && product.filterCategories"
    [class.i-filters]="product.colors || product.filtersLoreal"
    [class.is-sas]="product.subscribeAndSave"
    [class.no-price]="!showPrice"
    [attr.data-ts-resolved-bid] = "topsortResolvedBidId"
  >
    <app-quantity-controls class="add-button"
      *ngIf="showQuantityControl()"
      [class.add-information__add-button]="configModule?.additionalInf"
      [idPrefix]="idPrefix"
      [product]="product"
      [isCard]="true"
      [isMiniCard]="isMini"
      [isLorealDesign]="isLorealDesign"
      [isHome]="isHome"
      [isVTO]="isVTO"
      [queryID]="queryID"
      [positions]="positions + 1"
      [isSearchCards]="configModule?.additionalInf">
    </app-quantity-controls>

    <div *ngIf="redirectToDetail || product?.itemOpticsComplete" class="add-button add-information__add-button">
      <a class="add-information__add-button-link add-button__link" [routerLink]="[urlGo]">
        <img src="/assets/svg/arrow-right-white.svg" alt="detail" class="add-button__arrow-right" id="icon-detail-marketplace">
      </a>
    </div>

    <app-product-image class="product-image"
      [isAlgolia]="isAlgolia"
      [product]="product"
      [isSustitutes]="isSustitutes"
      [isMini]="isMini"
      [isCard]="true"
      [isHome]="isHome"
      [browser]="browser"
      [lazyLoaded]="lazyLoaded"
      [queryID]="queryID"
      [positions]="positions + 1"
      [isFavorite]="isFavorite"
      [discountsLoaded]="discountsLoaded"
      [class.product-image__mini]="isMini"
      [class.product-image--sustitutes]="isSustitutes"
      [class.add-information__product-image]="configModule?.additionalInf"
      [class.add-information__card-offer-product-image]="isOffer && configModule?.additionalInf">
    </app-product-image>

    <app-favorites-button class="btn-favorite"
      [class.btn-favorite__mini]="isMini"
      [class.btn-favorite--sustitutes]="isSustitutes"
      [isMini]="isMini"
      [product]="product"
      [border]="false">
    </app-favorites-button>

    <a
      class="content-product"
      [routerLink]="[urlGo]"
      (click)="algoliaEvent()"
    >
      <div class="text-left info" [class.product-rx]="requiresPrescription()">
        <p
          class="text-brand"
          *ngIf="(!isHome && !isOffer && !isSustitutes) || (isOffer && product?.totalStock)"
          [class.card-ftd__mini--brand]="isMini"
        >
          {{product.marca }}
        </p>

        <p class="text-title">
          {{product.description | titlecase }} {{product.detailDescription }}
        </p>

        <img
          class="icon-rx"
          *ngIf="requiresPrescription()"
          src="/assets/svg/icon-rx-blue.svg"
          alt="Formula Medica"
          title="Por su seguridad no se automedique"
        />
      </div>

      <div class="price text-left" *ngIf="(showPrice && !isOffer) || (isOffer && product?.totalStock)">
        <div *ngIf="configModule?.additionalInf?.price && product.taxes > 0" class="additional-information">
          <p class="price__text price__text-unit-price">{{product.unitPrice | multiCountryCurrency }}</p>
          <p class="price__text price__text-taxes">Iva {{product.taxes | multiCountryCurrency }}</p>
        </div>

        <p>
          <span 
            class="price__text-price"
            *ngIf="showPriceTag()"
            [ngClass]="{'price__full-price': !product.offerPrice && !product.primePrice }"
          >
            {{showPriceText() | multiCountryCurrency }}
          </span>
          <span 
            class="price__text-price"
            *ngIf="showPrimePriceTag()"
            [ngStyle]="{'color' : getPrimePriceColor() }"
          >
            {{product.primePrice | multiCountryCurrency }}
          </span>
          <span 
            class="price__text-offer-price"
            *ngIf="showPrimePriceText()"
            [class.offer-only]="!product.primePrice && !isSustitutes"
            [class.card-ftd__price-offer--sustitutes]="isSustitutes"
            >
              {{product.fullPrice | multiCountryCurrency}}
          </span>
        </p>

        <div *ngIf="shouldDisplayPrimePetal()">
          <app-prime-petal-long 
            *ngIf="shouldDisplayPrimePetalTag()"
            [customClasses]="'prime-petal-long--price'" 
            [value]="product.primePrice"
          ></app-prime-petal-long>
        </div>

        <div class="product-delivery-info" *ngIf="product.totalStock && !product.onlyOnline && !isFavorite && !isMini && !isSustitutes">
           <p class="price__text-price-unit">{{product.pum}}</p>
           <div class="detail-time-delivery">
            <img class="img-delivery-type" [src]="imgDeliveryType" alt=""/>
            <p class="text-delivery-time__online" *ngIf="deliveryType">{{ getDeliveryText() }}</p>
          </div>
        </div>

        <div class="product-delivery-info" *ngIf="product.totalStock && product.onlyOnline">
          <div>
            <p class="price__text-price-unit-marketplace1">Vendido por:</p>
            <p class="price__text-price-unit-marketplace2">{{ product?.supplier}}</p>
          </div>
          <div class="detail-time-delivery">
           <img class="img-delivery-type" [src]="imgDeliveryType" alt="imgDeliveryType" />
           <p class="text-delivery-time__online" >{{ getDeliveryText() }}</p>
         </div>
       </div>

      </div>
    </a>

    <div class="bz-calendar" *ngIf="!isMini && !isSustitutes"
      [class.hide]="product.subscribeAndSave"
      [class.add-space]="countryConfig.general.programAndSave && !product.subscribeAndSave">
      <div *ngIf="configModule?.additionalInf?.semaphore" class="additional-information">
        <app-product-petal [color]="product.petalColor " [text]="product.petalText"
          [size]="'small'">
        </app-product-petal>
      </div>

      <div class="bz-rating" *ngIf="showBzRating()">
        <div data-bv-show="inline_rating" [attr.data-bv-product-id]="product.id" data-bv-seo="false"></div>
      </div>

      <div class="bz-subscribe-available" *ngIf="!product?.totalStock ">
        <button *ngIf="!productsSubscription; else option "
          class="bz-subscribe-available__btn-large"
          [class.home]="isHome"
          (click)="saveNonStockItem(product?.id)"
        >{{txtSubscription}}</button>
        <ng-template #option>
          <button class="bz-subscribe-available__btn-large-active" (click)="removeNonStockItem(product?.id)">{{txtOnSubscription}}</button>
        </ng-template>
        <a class="btn-similar" (click)="searchWord(product)">Ver productos similares</a>
      </div>
    </div>

    <div class="topsort-tag" *ngIf="topsortTag">
      <span>Ad</span>
    </div>

    <div *ngIf="configModule?.additionalInf?.semaphore && isHome" class="additional-information">
      <app-product-petal
        [color]="product.petalColor"
        [text]="product.petalText"
        [size]="'mini'">
      </app-product-petal>
    </div>

    <div class="container-style-picker" *ngIf="!isHome && !isSustitutes">
      <!-- COLOR PICKER -->
      <div class="filters-container container-style-picker__filters-container" *ngIf="showColorPicker()">
        <button class="filters-container__button" *ngIf="colorPickerLimit()" (click)="prevFilter(product.id)"> &lsaquo; </button>
        <ul #contentFilter id="content-filter-{{product.id}}" class="filters-container__list color-picker">
          <li class="filters-container__list-item" *ngFor="let color of product.colors">
            <a class="filters-container__list-item-link" [routerLink]="[color.href]" [ngClass]="{'filters-container__list-item-active': product.color.name == color.name}">
              <span class="filters-container__list-item-span" [ngStyle]="{'background-color': color.hex}"></span></a>
          </li>
        </ul>
        <button class="filters-container__button" *ngIf="colorPickerLimit() " (click)="nextFilter(product.id)"> &rsaquo; </button>
      </div>
      <!-- TALLA -->
       <div class="container-style-picker__filters-container"
        *ngIf="showSizeTag()">
        <button class="filters-container__button" *ngIf="product.filtersLoreal.length > 3" (click)="prevFilter(product.id)"> &lsaquo; </button>
        <ul id="content-filter-{{product.id}}" class="filters-container__size-list"
          [ngClass]="{'filters-container__size-center': product.filtersLoreal.length <= 3}">
          <li class="filters-container__size-center" *ngFor="let filter of product.filtersLoreal">
            <a class="filters-container__size-link" [routerLink]="[filter.href]" [ngClass]="{'filters-container__size-active': product.id == filter.id}">
              <span class="filters-container__size-span">{{ filter.name}}</span>
            </a>
          </li>
        </ul>
        <button class="filters-container__button" *ngIf="product.filtersLoreal.length > 3" (click)="nextFilter(product.id)"> &rsaquo; </button>
      </div>
      <!-- VTO -->
      <div class="vto-container" *ngIf="showVtoTag(true)">
        <button class="vto-container__button" (click)="goToVTO(product)"> <img src="/assets/icons/camera.svg" alt="camera"> Probar </button>
      </div>

      <div class="vto-container" *ngIf="showVtoTag(false)">
        <button class="vto-container__button" (click)="goToDetailVTO(product)"> <img src="/assets/icons/camera.svg" alt="camera"> Probar </button>
      </div>
    </div>
    <app-button (click)="selectProductSus()" *ngIf="isSustitutes" class="btn-select-sustitute" [customClasses]="'main app-button--sustitutes'" [title]="'Seleccionar'"></app-button>
  </div>

  <app-suggest-card
    *ngIf="!product.type && groupType === 'suggests' && isResponsive"
    [groupType]="groupType"
    [isOffer]="isOffer"
    [isHalf]="columnHalf"
    [idPrefix]="idPrefix"
    [product]="product"
    [isMini]="isMini"
    [positions]="positions"
    [isHome]="isHome"
    [queryID]="queryID"
    [isAlgolia]="isAlgolia"
  ></app-suggest-card>

  <app-product-card-group
    *ngIf="product.type === 'GROUP'"
    [product]="product"
    [lazyLoaded]="lazyLoaded"
    [isHome]="isHome"
    [isFavorite]="isFavorite"
    [isOffer]="isOffer"
    [groupType]="groupType"
    [columnHalf]="columnHalf"
  ></app-product-card-group>
</div>

<!-- ---------- search card  ---------- -->
<div class="card-large"
  data-ts-clickable
  *ngIf="!showCard"
  [class.withPetals]="countryConfig.productCard.petals"
  [attr.data-ts-resolved-bid] = "topsortResolvedBidId">

  <app-quantity-controls
    *ngIf="showQuantityControl()"
    [idPrefix]="idPrefix"
    [product]="product"
    [isCard]="true"
    [isMiniCard]="isMini"
    [isLorealDesign]="isLorealDesign"
    class="add-button"
    [isHome]="isHome"
    [isVTO]="isVTO"
    [queryID]="queryID"
    (click)="stopEvent($event)"
    [positions]="positions + 1"
    [isSearchCards]="configModule?.additionalInf">
  </app-quantity-controls>
  <div *ngIf="redirectToDetail" class="add-information__add-button">
    <a class="add-information__add-button-link add-button__link" [routerLink]="[urlGo]">
      <img src="/assets/svg/arrow-right-white.svg" alt="detail" class="title" id="icon-detail-marketplace">
    </a>
  </div>
  <app-product-image 
    class="card-large__product-image"
    [isAlgolia]="isAlgolia" 
    [product]="product"
    [isSustitutes]="isSustitutes"
    [isMini]="isMini" [isCard]="true"
    [isHome]="isHome"
    [browser]="browser"
    [lazyLoaded]="lazyLoaded"
    [queryID]="queryID"
    [positions]="positions + 1"
    [isFavorite]="isFavorite"
  ></app-product-image>

  <div class="card-large__content-product" [class.i-cont-description-vto]="!isVTO && product.filterCategories">

    <app-favorites-button
      class="btn-favorite"
      [product]="product"
      [border]="false">
    </app-favorites-button>

    <div class="text-title">
      <span class="brand-add">
        <p class="text-brand">{{ product.marca }}</p>
      </span>
      <a class="link" [routerLink]="[urlGo]">
        <h2 class="title">{{ product.description | titlecase }}</h2>
      </a>
      <img class="icon-rx"
        *ngIf="requiresPrescription()"
        src="/assets/svg/icon-rx-blue.svg"
        alt="Formula Medica"
        title="Por su seguridad no se automedique">
    </div>
    <div class="cont-price">
        <span class="cont-price__text-price"
          *ngIf="showPriceTag()">
          {{showPriceText() | multiCountryCurrency }}
        </span>

        <span class="cont-price__text-price"
          *ngIf="showPrimePriceTag()"
          [ngStyle]="{'color' : getPrimePriceColor() }">
          {{product.primePrice | multiCountryCurrency }}
        </span>

        <span class="cont-price__text-offer-price"
          *ngIf="showPrimePriceText()"
          [ngClass]="{'offer-only': !product.primePrice }">
          {{product.fullPrice | multiCountryCurrency}}
        </span>

        <div *ngIf="shouldDisplayPrimePetal()">
          <app-prime-petal-long 
            *ngIf="shouldDisplayPrimePetalTag()"
            [customClasses]="'prime-petal-long--price'" 
            [value]="product.primePrice"
          ></app-prime-petal-long>
        </div>
        <p class="cont-price__text-price-unit" *ngIf="product.pum && !isMini">{{product.pum}}</p>
    </div>

    <div class="cont-time" *ngIf="product.totalStock">
        <div class="petal-stars" *ngIf="countryConfig.productCard.petals">
          <div *ngIf="configModule?.additionalInf?.semaphore" class="additional-information">
            <app-product-petal
              [color]="product.petalColor"
              [text]="product.petalText"
              [size]="'small'">
            </app-product-petal>
          </div>

          <div class="bz-rating">
            <div class="inline_rating" data-bv-show="inline_rating"
              [attr.data-bv-product-id]="product.id"
              data-bv-seo="false">
            </div>
          </div>
        </div>

        <div class="calendar" *ngIf="!!product.deliveryTime && !product.subscribeAndSave">
          <div class="bz-rating">
            <div data-bv-show="inline_rating"
              [attr.data-bv-product-id]="product.id"
              data-bv-seo="false">
            </div>
          </div>
          <div class="card-ftd__container">
            <img class="img-delivery-type"
              [src]="imgDeliveryType"
              [alt]="'Tiempo de envio ' + product.deliveryTime">
            <span class="card-ftd__online">{{ getDeliveryText() }}</span>
          </div>
        </div>
      </div>

      <div class="topsort-tag" *ngIf="topsortTag">
        <span>Ad</span>
      </div>

    <div class="container-style-picker" [ngClass]="{'container-style-picker__large': !(!isVTO && product.filterCategories)}">
         <!-- COLOR PICKER -->
      <div class="container-style-picker__filters-container first-home" *ngIf="product && product.colors">
        <button class="filters-container__button" *ngIf="product.colors.length > 3" (click)="prevFilter(product.id)"> &lsaquo; </button>
        <ul #contentFilter id="content-filter-{{product.id}}" class="filters-container__list color-picker">
          <li class="filters-container__list-item" *ngFor="let color of product.colors">
            <a class="filters-container__list-item-link" [routerLink]="[color.href]" [ngClass]="{'filters-container__list-item-active': product.color?.name == color.name}">
              <span class="filters-container__list-item-span" [ngStyle]="{'background-color': color.hex, 'border': 'solid 1px #ebebeb'}"></span></a>
          </li>
        </ul>
        <button class="filters-container__button" *ngIf="product.colors.length > 3" (click)="nextFilter(product.id)"> &rsaquo; </button>
      </div>
        <!-- TALLA -->
      <div class="container-style-picker__filters-container" *ngIf="showSizeTag()">
        <button class="filters-container__button" *ngIf="product.filtersLoreal.length > 3" (click)="prevFilter(product.id)"> &lsaquo; </button>
          <ul id="content-filter-{{product.id}}" class="filters-container__size-list"
            [ngClass]="{'justify-center': product.filtersLoreal.length <= 3}">
            <li class="filters-container__size-item" *ngFor="let filter of product.filtersLoreal">
              <a class="filters-container__size-link" [routerLink]="[filter.href]" [ngClass]="{'filters-container__size-active': product.id == filter.id}">
                <span class="filters-container__size-span">{{ filter.name}}</span></a>
            </li>
          </ul>
          <button class="filters-container__button" *ngIf="product.filtersLoreal.length > 3" (click)="nextFilter(product.id)"> &rsaquo; </button>
        </div>

        <!-- PROBAR EN VIVO -->
      <div class="vto-container cont-detail" *ngIf="!isVTO && product.filterCategories">
        <button class="vto-container__button" (click)="goToVTO(product)"> <img src="/assets/icons/camera.svg" alt=""> Probar
        </button>
      </div>
    </div>

    <div class="bz-subscribe-available" *ngIf="!product.totalStock ">
      <button class="bz-subscribe-available__btn-large" (click)="saveNonStockItem(product?.id)"
        *ngIf="!productsSubscription; else option ">{{txtSubscription}}</button>
      <ng-template #option>
        <button class="bz-subscribe-available__btn-large-active" (click)="removeNonStockItem(product?.id)">{{txtOnSubscription}}</button>
      </ng-template>
      <a class="btn-view-more" (click)="searchWord(product)">Ver productos similares</a>
    </div>

    <div *ngIf="product?.itemOpticsComplete" class="add-button add-information__add-button">
      <a class="add-information__add-button-link add-button__link" [routerLink]="[urlGo]">
        <img src="/assets/svg/arrow-right-white.svg" alt="detail" class="add-button__arrow-right" id="icon-detail-marketplace">
      </a>
    </div>
  </div>
</div>

<!-- ---------- Flash Offer ---------- -->

<app-flash-offer
  *ngIf="isFlashOffer"
  [isAlgolia]="isAlgolia"
  [product]="product"
  [isSustitutes]="isSustitutes"
  [isMini]="isMini"
  [isHome]="isHome"
  [lazyLoaded]="lazyLoaded"
  [queryID]="queryID"
  [positions]="positions + 1"
  [subs]="subs"
  [isFlashOffer]="isFlashOffer">
</app-flash-offer>

<app-vto-player></app-vto-player>
